import React from 'react';
import { styled, Typography } from '@mui/material';
import { format, isValid } from 'date-fns';
import FormField from 'components/form-page/FormField';
import { RecordNote } from 'components/record-shell/RecordShell';
import { Surgerie } from 'types/surgerie';

const Grid = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
  gap: theme.spacing(2),
  [theme.breakpoints.down('md')]: { gridTemplateColumns: 'repeat(2, minmax(0, 1fr))' },
  [theme.breakpoints.down('sm')]: { gridTemplateColumns: '1fr' },
}));

function formatDateTime(value: Date | string | null, by: string | null) {
  if (!value) return 'Não informado';

  const date = new Date(typeof value === 'string' ? value.replace(' ', 'T') : value);
  const day = isValid(date) ? format(date, 'dd/MM/yyyy HH:mm') : 'Não informado';

  return by ? `${day} por ${by}` : day;
}

interface SurgerieGeneralTabProps {
  budget: Surgerie;
}

const SurgerieGeneralTab: React.FC<SurgerieGeneralTabProps> = ({ budget }) => {
  const doctor = budget.doctor?.doctor;
  const fields: [string, string][] = [
    ['Paciente', budget.patient?.name || 'Não informado'],
    ['Procedimento', budget.procedure?.name || 'Não informado'],
    ['Especialidade', budget.specialty?.name || 'Não informado'],
    ['Médico', doctor ? `${doctor.name}${doctor.crm ? ` (CRM ${doctor.crm})` : ''}` : 'Não informado'],
    ['Hospital', budget.hospital?.company_name || 'Não informado'],
    ['Criado em', formatDateTime(budget.created_at, budget.created_by)],
  ];

  if (budget.status === 'closed') fields.push(['Fechado em', formatDateTime(budget.closed_at, budget.closed_by)]);

  return (
    <>
      <Grid>
        {fields.map(([label, value]) => (
          <FormField key={label} label={label}>
            <Typography variant="body2">{value}</Typography>
          </FormField>
        ))}
      </Grid>
      <div style={{ marginTop: 16 }}>
        <RecordNote>Paciente, procedimento, médico e hospital só mudam criando outro orçamento.</RecordNote>
      </div>
    </>
  );
};

export default SurgerieGeneralTab;
